import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './InspCarouselItem.css';

class InspCarouselItem extends Component { //eslint-disable-line
  static propTypes = {
    CarouselItemData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    strings: React.PropTypes.shape({}),
    CarousalHeaderTitle: React.PropTypes.string,
    currentLanguage: React.PropTypes.string,
    isIE: React.PropTypes.bool
    // carouselHeaderText: React.PropTypes.string,
    // carousalHeaderTitle: React.PropTypes.string
  }
  pushPlaceholderElements = (element, propsHeader) => {
    const MAX_LENGTH = (propsHeader === 'Policy Details' || propsHeader === 'Detalles de la póliza') ? 3 : 4;
    const placeholdersLength = MAX_LENGTH - element.length;
    const newPlaceholderArray = [...element];
    for (let x = 0; x < placeholdersLength; x += 1) {
      newPlaceholderArray.push({ title: '', subTitle: '' });
    }
    return newPlaceholderArray;
  }
  carouselData = () => {
    const carouselItemData = this.props.CarouselItemData;
    return carouselItemData;
  }
  render() {
    let columnSubElements = [];
    const { strings } = this.props;
    let campaignPurposeTitle = '';
    let campaignPurposeSubTitle = '';
    if (this.props.CarouselItemData) {
      switch (this.props.CarouselItemData.type) {
        case 'ropTable': {
          const tableDataObj = this.carouselData().tableData[0];
          const campaignPupose = tableDataObj.campaignPurpose;
          return (
            <div className={styles.carouselMainSection} >
              <div className={styles.carouselTableSection} >
                {
                  <div className={styles.flexContainer} >
                    {
                      this.carouselData().tableData.map((tableData, _index2) =>
                        <div className={styles.tableMainDiv} key={`maindiv, ${_index2}`}>
                          <table className={styles.tableStyle} key={_index2}>
                            <thead key={`thead, ${_index2}`}>
                              <tr className={styles.tableRowROP} key={`tr, ${_index2}`}>
                                {
                                  tableData.header.map((header, _index3) =>
                                    <td className={styles.tableDivInnerHeader} key={`td, ${_index3}`}>
                                      <span className={styles.boldSpanFontROP} key={`span_, ${_index3}`}>{header}</span>
                                    </td>
                                  )}
                              </tr>
                            </thead>
                            <tbody key={`tbody, ${_index2}`}>
                              {
                                tableData.body.map((ropRow, _index3) =>
                                  <tr key={_index3} className={styles.tableRowROP}>
                                    {
                                      Object.keys(ropRow).map((ropCell, _index4) =>
                                        <td className={styles.tableDivInnerROP} key={`td, ${_index4}`}>
                                          {ropCell === 'cica_roppolicynumber' &&
                                            <span className={styles.bodySpanFontROP}>
                                              <input
                                                type="checkbox"
                                                value="selected"
                                                id={`input_in_${_index2}_${_index3}_${_index4}`}
                                                className={styles.boldAnchorSpanFont}
                                                key={`input_in_${_index4}`}
                                              />
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`}>
                                                {ropRow[ropCell]}
                                              </label>
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`} className={styles.starMasks} key={`span_, ${_index3}, _star`}>**</label>
                                            </span>
                                          }
                                          {ropCell !== 'cica_roppolicynumber' &&
                                            <span className={styles.bodySpanFontROP} key={`span_, ${_index4}`}>{ropRow[ropCell]}</span>
                                          }

                                        </td>
                                      )
                                    }
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    <div className={styles.belowTable}>
                      <span className={styles.subSpanFontROP} key={'staticForMoreDetailsROP'}>{strings.forMoreInfo}</span>
                    </div>
                    <div className={styles.belowTableROP}>
                      <span className={styles.bigBoldSpanFontROP} key={'staticROPCampaignHeader'}>{strings.campaignPurpose}</span>
                      <span className={styles.subSpanFontSubROP} key={'staticROPCampaignText'}>{`${campaignPupose}`}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          );
        }
        case 'table':
          return (
            <div className={styles.carouselMainSection} >
              <div className={styles.carouselTableSection} >
                {
                  <div className={styles.flexContainer} >
                    {
                      this.carouselData().tableData.map((tableData, _index2) =>
                        <div className={styles.tableMainDiv} key={`maindiv, ${_index2}`}>
                          <div className={styles.tableTitleDiv} key={`tabletitle, ${_index2}`}>
                            <span className={styles.tableTitleSpan} key={`tableTitleSpan, ${_index2}`}>{tableData.tableTitle}</span>
                          </div>
                          <table className={styles.tableStyle} key={_index2}>
                            <thead key={`thead, ${_index2}`}>
                              <tr className={styles.tableRow} key={`tr, ${_index2}`}>
                                {
                                  tableData.header.map((subItems, _index3) =>
                                    <td className={styles.tableDivInner} key={`td, ${_index3}`}>
                                      <span className={styles.boldSpanFont} key={`span_, ${_index3}`}>{subItems}</span>
                                    </td>
                                  )}
                              </tr>
                            </thead>
                            <tbody key={`tbody, ${_index2}`}>
                              {
                                tableData.body.map((tableBodyRows, _index3) =>
                                  <tr key={_index3} className={styles.tableRow}>
                                    {
                                      tableBodyRows.map((tableBodyItems, _index4) =>
                                        <td className={(tableBodyItems.name === 'insuredName') ? styles.tableDivInnerName : styles.tableDivInner} key={`td, ${_index4}`}>
                                          {tableBodyItems.name === 'policyNumber' &&
                                            <span className={(tableBodyItems.name === 'insuredName') ? styles.bodySpanFontName : styles.bodySpanFont}>
                                              <input
                                                type="checkbox"
                                                value="selected"
                                                id={`input_in_${_index2}_${_index3}_${_index4}`}
                                                className={styles.boldAnchorSpanFont}
                                                key={`inpur_in_${_index4}`}
                                              />
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`}>
                                                {tableBodyItems.value}
                                              </label>
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`} className={styles.starMasks} key={`span_, ${_index3}, _star`}>**</label>
                                            </span>

                                          }
                                          {tableBodyItems.name !== 'policyNumber' &&
                                            <span className={(tableBodyItems.name === 'insuredName' && tableBodyItems.value.length > 12) ? styles.bodySpanFontName : styles.bodySpanFont} key={`span_, ${_index4}`}>{tableBodyItems.value}</span>
                                          }
                                        </td>
                                      )
                                    }
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    <div className={styles.belowTable}>
                      {
                        this.carouselData().footerData.map((footerDataRows, _index3) =>
                          <div key={`div, ${_index3}`} >
                            <span className={_index3 === 0 ? styles.bigBoldSpanFont : styles.boldSpanFont} key={`span1_, ${_index3}`}>{footerDataRows.title}</span>
                            <span className={styles.subSpanFont} key={`span2_, ${_index3}`}>{footerDataRows.subTitle}</span>
                          </div>
                        )}
                    </div>
                  </div>
                }
              </div>
            </div>
          );
        case 'OtherCampaignsFlexDivs':
          return (
            <div className={styles.carouselMainDivSection}>
              <div className={styles.carouselMainSectionNROP} >
                {
                  this.props.CarouselItemData &&
                  this.carouselData().subItems.map((subItems, _index2) =>
                    <div className={styles.tableStyle} key={_index2}>
                      {subItems.subElements.map((subElements, _index3) => {
                        if (subElements.title === 'Campaign Purpose:' || subElements.title === 'Propósito de la campaña:') {
                          campaignPurposeTitle = subElements.title;
                          campaignPurposeSubTitle = subElements.subTitle;
                          return '';
                        }
                        return (
                          <div className={styles.labelSubElement} key={_index3}>
                            <div
                              className={styles.labelCampaignTitle}
                              key={`subQuestion, ${_index3}!`}
                            >
                              {subElements.title}
                            </div>
                            <div
                              className={(subElements.title === 'Campaign Name:' || subElements.title === 'Nombre de campaña:') ? styles.subLabelCampaignName : styles.labelCampaignSubTitle}
                              key={`subAnswer, ${_index3}!`}
                            >
                              {subElements.subTitle}
                            </div>
                          </div>
                        );
                      }
                      )}
                    </div>
                  )}
              </div>
              {
                (campaignPurposeTitle !== '' && campaignPurposeSubTitle !== '') &&
                <div className={styles.belowTableDiv}>
                  <div>
                    <span className={styles.subSpanFontROP} key={'staticForMoreDetailsCamp'}>{strings.forMoreInfo}</span>
                  </div>
                  <div className={styles.spacer} />
                  <div className={styles.bigBoldSpanFontText}>
                    {campaignPurposeTitle}
                  </div>
                  <div className={styles.labelSubAnswerWarm}>
                    {campaignPurposeSubTitle}
                  </div>
                </div>
              }
            </div>
          );
        default:
          return (
            <div className={styles.containerDiv}>
              <table className={styles.tableClass}>
                {
                  this.props.CarouselItemData.map((columnItems, index1) => {
                    columnSubElements = this.pushPlaceholderElements(columnItems.subElements,
                      this.props.CarousalHeaderTitle);
                    return (<tbody className={styles.rowItems} key={`columnItems, ${index1}`}>
                      {
                        columnSubElements.map((rowItems, index2) =>
                          <tbody className={styles.individualItem} key={`rowItems, ${index2}`}>
                            <tr className={(this.props.currentLanguage === 'es' && rowItems.title === 'Fecha de nacimiento del asegurado') ? styles.itemHeadEs : styles.itemHead} style={this.props.isIE ? { letterSpacing: '1.2px' } : {}}>
                              <th style={{ textAlign: 'left' }}>
                                {rowItems.title}
                              </th>
                            </tr>
                            <tr className={styles.itemBody}>
                              <td className={styles.itemBodyInner}>
                                {(rowItems.title.indexOf('Address') > -1 || rowItems.title.indexOf('Domicilio') > -1) && rowItems.subTitle.split('<p>').map((item, key) => (
                                  <div key={key}>{ item }</div>
                                ))}
                                {(rowItems.title.indexOf('Address') === -1 && rowItems.title.indexOf('Domicilio') === -1) && rowItems.subTitle}
                              </td>
                            </tr>
                          </tbody>
                        )
                      }
                    </tbody>);
                  })
                }
              </table>
              { (this.props.CarousalHeaderTitle === 'Policy Details' || this.props.CarousalHeaderTitle === 'Detalles de la póliza') &&
                <div className={styles.affordability}>
                  <sup>*</sup>{strings.combinedProducts}
                </div>
              }
              { (this.props.CarousalHeaderTitle !== 'Policy Details' || this.props.CarousalHeaderTitle !== 'Detalles de la póliza') &&
                <div className={styles.placeholderDiv} />
              }
            </div>
          );
      }
    }
    return '';
  }
}

const mapStateToProps = state => ({
  currentLanguage: state.assign && state.assign.currentLanguage
});

export default connect(mapStateToProps, null)(InspCarouselItem);



// WEBPACK FOOTER //
// ./src/components/InspCarouselItem/InspCarouselItem.js